import { Component, Input, SimpleChanges, ViewChild, ElementRef, forwardRef, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isObservable } from 'rxjs';

export interface BbFacetListOption {
	value: string;
	label: string;
	amount: number;
	selected?: boolean;
}

@Component({
	selector: 'bb-facet-list',
	templateUrl: './bb-facet-list.component.html',
	styleUrls: ['./bb-facet-list.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbFacetListComponent),
		multi: true
	}]
})

export class BbFacetListComponent implements ControlValueAccessor, OnInit, OnChanges {

	@Input() fieldName: string;
	@Input() options: BbFacetListOption[];
	@Input() facetsLoading = false;
	@Input() valueLabelMap: any = {};
	@ViewChild('facetSearchInput') facetSearchInput: ElementRef;

	selected: any[];
	filteredOptions: BbFacetListOption[];
	facetSearch: string;
	numResultsShown: number;
	totalNumber: number;
	propagateChange: any;
	value: string[] = [];

	constructor() {
		this.selected = [];
		this.facetSearch = '';
		this.numResultsShown = 15;
	}

	@Input() focusInput() {
		setTimeout(() => {
			if (this.facetSearchInput) {
				this.facetSearchInput.nativeElement.focus();
			}
		});
	}

	isAsyncValue(val: any): boolean {
		return (val instanceof Promise || isObservable(val));
	}

	ngOnInit() { }


	ngOnChanges(changesObj: SimpleChanges) {
		if (changesObj) {
			for (const key in changesObj) {
				if (key === 'options' && this.options) {
					this.filterValues();
				}
			}
		}
	}

	optionChecked(value: string, checked: boolean) {

		const index = this.value.indexOf(value);

		if (checked && index === -1) {
			this.value.push(value);
			this.selectItem(value);
		} else if (!checked && index > -1) {
			this.value.splice(index, 1);
			this.deSelectItem(value);
		}

		if (typeof this.propagateChange !== 'undefined') {
			this.propagateChange(this.value);
		}
	}

	filterValues() {
		const filtered = this.options.filter((item: BbFacetListOption) => item &&
			(((item.label || item.label === '') && item.label.toLowerCase && item.label.toLowerCase().indexOf(this.facetSearch.toLowerCase()) !== -1)) ||
			(((item.value || item.value === '') && item.value.toLowerCase().indexOf(this.facetSearch.toLowerCase()) !== -1)) ||
			item.selected);
		this.totalNumber = filtered.length;

		this.filteredOptions = filtered.splice(0, this.numResultsShown);
	}

	inputChanged(ev: UIEvent, fieldName: string) {
		// if (ev && ev.target && (ev.target as HTMLInputElement).value) {
		// 	let val = (ev.target as HTMLInputElement).value;
		// }
	}

	writeValue(value: string[]) {
		this.value = (value ? value : []);
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() { }

	private selectItem(val: string) {
		const length = this.filteredOptions.length;
		for (let i = 0; i < length; i++) {
			if (this.filteredOptions[i] && this.filteredOptions[i].value === val) {
				this.filteredOptions[i].selected = true;
			}
		}
	}
	private deSelectItem(val: string) {
		const length = this.filteredOptions.length;
		for (let i = 0; i < length; i++) {
			if (this.filteredOptions[i] && this.filteredOptions[i].value === val) {
				this.filteredOptions[i].selected = false;
			}
		}
	}
}
